import React from 'react';
import dynamic from 'next/dynamic';
import { makeStyles } from 'src/makeStyles';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';

import { get } from 'lodash';
import route from 'constants/routes';
import { PRODUCTION_ADDED_IDENTIFIERS_IDS, TP } from 'constants/consts';
import { getRoutePartWithSlug } from 'utils/common';
import { colors, fontFamilies } from 'constants/styleConstants';
import { useTranslation } from 'src/i18n';

const DateBlock = dynamic(() => import('../ProductionDateBlock'));

const useStyles = makeStyles()({
  monthBlock: {
    margin: 2,
    display: 'flex',
    flexWrap: 'wrap',
  },
  link: {
    color: colors.blueChip,
    cursor: 'pointer',
  },
  producerTitle: {
    color: colors.grey2,
    fontSize: 14,
    fontFamily: fontFamilies.ROBOTO_BOLD,
  },
  hostedByContainer: {
    marginRight: 5,
  },
});

const ProductionDatesContent = ({ className, formattedDates, cancelled, showHostedBy }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();
  const handleCompanyOrFestivalClick = (e, item) => {
    if (item?.entity?.id !== -1) {
      e.stopPropagation();

      if (item?.entityType === PRODUCTION_ADDED_IDENTIFIERS_IDS.COMPANY) {
        window.open(`${route.COMPANIES}/${item?.entity?.slug}/${getRoutePartWithSlug(item?.entity)}`);
      }
      if (item?.entityType === PRODUCTION_ADDED_IDENTIFIERS_IDS.FESTIVAL) {
        window.open(`${route.FESTIVALS}/${item?.entity?.slug}/${getRoutePartWithSlug(item?.entity)}`);
      }
    }
  };

  return (
    <Grid item className={cx(classes.root, className)}>
      {formattedDates && (
        <>
          {Object.keys(formattedDates).map((key, index) => (
            <>
              <DateBlock
                key={`${key}-${index}`}
                title={key}
                dates={get(formattedDates, key, [])}
                className={classes.monthBlock}
                isCancelled={cancelled}
              />
              {formattedDates?.[key]?.[index]?.hostedBy?.entity?.id && showHostedBy && (
                <span className={classes.hostedByContainer}>
                  <span className={classes.producerTitle}>
                    {t(`${TP}.FN_HOSTED_BY`)}:{`\u00A0`}
                  </span>
                  <span
                    role="presentation"
                    onClick={e => handleCompanyOrFestivalClick(e, formattedDates?.[key]?.[index]?.hostedBy)}
                    onKeyDown={e => handleCompanyOrFestivalClick(e, formattedDates?.[key]?.[index]?.hostedBy)}
                    className={classes.link}
                  >
                    {formattedDates?.[key]?.[index]?.hostedBy?.entity?.name}
                  </span>
                </span>
              )}
            </>
          ))}
        </>
      )}
    </Grid>
  );
};

ProductionDatesContent.propTypes = {
  formattedDates: PropTypes.object,
  className: PropTypes.string,
};

export default ProductionDatesContent;
